<div [ngClass]="['page', hasSide ? 'hasOut' : '']" [ngStyle]="{'grid-template-columns': hasSide && gridTemplateColumns ? gridTemplateColumns : ''}">
  <div>
    <ng-content></ng-content>
  </div>
  <div>
    <router-outlet (activate)="hasSide = true" (deactivate)="hasSide = false"></router-outlet>
  </div>
</div>
